import { useState } from 'react';
import { WatchlistTable } from '../components/watchlist/WatchlistTable';
import { ScenarioType } from '../components/watchlist/types';
import FundInsightsPreview from '../components/super-investors/FundInsightsPreview';
import { EarningsInsightsPreview } from '../components/earnings/EarningsInsightsPreview';

export function Dashboard() {
  const [selectedScenario, setSelectedScenario] = useState<ScenarioType>('base');
  return (
    <div className="w-full min-h-screen bg-theme-primary p-6">
      <div className="max-w-7xl mx-auto space-y-8">
        {/* Fund Insights Preview Section */}
        <section>
          <FundInsightsPreview />
        </section>

        {/* Earnings Insights Preview Section */}
        <section>
          <EarningsInsightsPreview />
        </section>

        {/* Watchlist Section */}
        <section>
          <h1 className="text-2xl font-bold text-theme-primary mb-6">
            Your Watchlist
          </h1>
          <WatchlistTable selectedScenario={selectedScenario} onScenarioChange={setSelectedScenario} />
        </section>
      </div>
    </div>
  );
}